/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { array, object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';

import { blogContentTruncate } from '../../../../../../helpers/commonFunctions';

const styles = (theme) => {
    const { breakpoints: { minWidth, maxWidth } } = theme;
    return ({
        root: {
            maxWidth: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            backgroundColor: '#F8F8F8',
            border: 'none',
            boxShadow: 'none',
            [theme.breakpoints.up(maxWidth?.xs_large_screen_up)]: {
                margin: `0 ${theme.spacing(3)}px`,
            },
            '& .slick-slider button': {
                display: 'none',
            },
            '& .MuiCardHeader-title': {
                fontSize: '1.625rem',
                fontFamily: theme.typography.secondaryFontFamily,
                paddingBottom: theme.spacing(2),
                minHeight: 73,
                [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.small_medium_down)]: {
                    fontSize: '1.25rem',
                    minHeight: '43px',
                    lineHeight: '1.5',
                },
            },
            '& .MuiCardHeader-subheader': {
                fontSize: '0.75rem',
                fontFamily: theme.palette.common.black,
            },
        },
        headerWrapper: {
            paddingBottom: 0,
            [theme.breakpoints.down(minWidth?.xs_large_screen_up)]: {
                order: 2,
            },
        },
        media: {
            height: 0,
            paddingTop: '56.25%', // 16:9
            width: '100%',
            [theme.breakpoints.down(minWidth?.xs_large_screen_up)]: {
                order: 1,
            },
        },
        contentWrapper: {
            maxHeight: 110,
            minHeight: 110,
            margin: '1rem',
            [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.small_medium_down)]: {
                padding: `${theme.spacing(2)}px`,
                '& p': {
                    fontSize: '0.8125rem',
                    lineHeight: '18px !important',
                },
            },
            '& p': {
                margin: 0,
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
            },
            [theme.breakpoints.down(minWidth?.xs_large_screen_up)]: {
                order: 3,
                marginBottom: 0,
                '& p': {
                    paddingTop: 0,
                    fontSize: '0.875rem',
                },
            },
        },
        blogButton: {
            border: `1px solid ${theme.palette.common.gray}`,
            cursor: 'pointer',
            padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            backgroundColor: 'transparent',
            color: 'inherit',
            textDecoration: 'none',
            [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.small_medium_down)]: {
                padding: '8px 20px',
            },
        },
        buttonWrapper: {
            margin: '1rem auto 3rem',
            [theme.breakpoints.down(minWidth?.xs_large_screen_up)]: {
                order: 4,
            },
        },
    });
};

const ProductBlogContent = ({ classes, blogDetails }) => (
    <Card className={classes.root}>
        <CardHeader className={classes.headerWrapper} title={blogDetails.blogTitle} subheader={blogDetails.blogDate} />
        <CardMedia
            className={classes.media}
            image={blogDetails.blogImg}
            title={blogDetails.blogTitle}
        />
        <CardContent className={classes.contentWrapper}>
            <p>{blogContentTruncate(blogDetails.blogContent, 180, ' ...')}</p>
        </CardContent>
        <CardActions className={classes.buttonWrapper}>
            <a href={blogDetails.blogLink} target="_blank" rel="noreferrer" aria-label={blogDetails.blogTitle} className={classes.blogButton}>READ MORE</a>
        </CardActions>
    </Card>
);

ProductBlogContent.propTypes = {
    blogDetails: array.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(ProductBlogContent);
